"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _index = _interopRequireDefault(require("../headline-lockup/index.js"));
var _form = _interopRequireDefault(require("./form"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
/**
 * Local Imports
 */

/**
 * SSLChecker Component.
 *
 * @param {Object} props React props
 * @param {string} props._name Tracking name of the section
 * @param {string} props.verticalPadding Vertical Inner Spacing
 * @param {string} props.verticalMargin Vertical Outer Spacing
 * @param {Object} props.backgroundColor Section background color
 * @param {boolean} props.invert Inverted styles
 * @returns {React.ReactElement} SSLChecker Component
 * @public
 */

function SSLChecker({
  _name,
  verticalPadding = 'small',
  verticalMargin,
  backgroundColor,
  invert,
  partial,
  ...rest
}) {
  return /*#__PURE__*/_react.default.createElement(_section.default, {
    _name: _name,
    dataCy: "ssl-checker-section",
    verticalPadding: verticalPadding,
    verticalMargin: verticalMargin,
    backgroundColor: (0, _patternLibraryUtils.getBackgroundColor)(backgroundColor),
    partial: partial || (invert ? 'dark1' : '')
  }, /*#__PURE__*/_react.default.createElement(_index.default, rest), /*#__PURE__*/_react.default.createElement(_form.default, rest));
}
var _default = exports.default = SSLChecker;
SSLChecker.propTypes = {
  _name: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  invert: _propTypes.default.bool,
  partial: _propTypes.default.string,
  ..._patternLibraryUtils.marginProps,
  ..._patternLibraryUtils.paddingProps
};